(function (factory) {
	var moduleName = "cnetReviewVideo";

	if (typeof ccs_define === "function") {
		ccs_define(moduleName, ["jquery", "videoPlayer"], factory);
		return;
	}

	var moduleExport = factory(window.ccsJq);
	if (typeof moduleExport !== "undefined") {
		window[moduleName] = moduleExport;
	}
}
(function ($) {
	var defaults = {
		videoDesktopUrl: "data-desktop-video-url",
		videoMobileUrl: "data-mobile-video-url",

		videoPlayer: {
			pluginPath: "from server",
			embedContainerId: "from server",
			previewImageUrl: "from server",
			autoPlayVideoInViewPort: "from server"
		}
	};

	function initialize(options) {
		var o = options;

		var $videoContainer = $("#" + o.videoPlayer.embedContainerId);

		if ($videoContainer.length === 0)
			return;

		var thumbnail = $("<img>")
			.attr("src", o.videoPlayer.previewImageUrl)
			.attr("class", "ccs-logo-cr-review_video_thumbnail")
			.attr("alt", "First look video")
			.appendTo($videoContainer);

		var videoUrl = parseVideoData($videoContainer, o);

		var settings = {
			file: videoUrl,
			image: o.videoPlayer.previewImageUrl,
			width: "100%",
			ccUrl: $videoContainer.data("cc-url"),
			ccLang: $videoContainer.data("cc-lang"),
			playOnInit: true,
			mute: false,
			volume: 80,
			pluginPath: o.videoPlayer.pluginPath,
			tracking: {
				logCall: $videoContainer.attr("data-video-log-call")
			}
		};

		var button = $videoContainer.find(".ccs-logo-cr-playBtn")
			.click(function () {
				intializeVideo($videoContainer, button, thumbnail, settings);
			});

		if (ccs_util.isMobile()) {
			(function whenVisible() {
				if ($videoContainer.is(":visible")) {
					intializeVideo($videoContainer, button, thumbnail, settings);
				}
				else {
					setTimeout(whenVisible, 100);
				}
			}());

			return;
		}

		if (o.videoPlayer.autoPlayVideoInViewPort) {
			var isVisible = function () {
				if ($videoContainer.is(":visible")) {
					settings = $.extend(settings,
						{
							initByAutoplay: true,
							mute: true,
							height: $videoContainer.height(),
							pluginPath: o.pluginPath
						});


					$.ccsVideoPlayer.initAutoPlay($videoContainer, settings);
					button.css("display", "none");
					thumbnail.css("display", "none");
				} else {
					setTimeout(isVisible, 300);
				}
			};

			setTimeout(isVisible, 100); //wait the content loading for the correct calculation of the target area
		}
	}

	function intializeVideo($videoContainer, button, thumbnail, settings) {
		button.css("display", "none");
		thumbnail.css("display", "none");
		settings = $.extend(settings, { height: $videoContainer.height() });

		$videoContainer.ccsVideoPlayer(settings);
	}

	function parseVideoData($videoContainer, o) {
		var urlAttr = o.videoDesktopUrl;

		if (ccs_util.isMobile()) {
			urlAttr = o.videoMobileUrl;
		}

		return $videoContainer.attr(urlAttr);
	}

	function cnetReviewVideo(options) {
		var o = $.extend(true, {}, defaults, options);

		initialize(o);
	}

	window.CnetReviewVideo = cnetReviewVideo;
}));
